import { PlusOutlined } from '@ant-design/icons';
import { AppTable } from 'shared/UI/UIKit/Table';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { useScheduleEducationPlans } from '../model';
import styles from './styles.module.scss';
import { PrePublishErrorsModal } from './components';

export const ScheduleEducationPlans = () => {
  const {
    state: {
      dataSource,
      columns,
      filteredColumns,
      visibleKeys,
      loading,
      tableState,
      prePublishErrorsModalVisible,
      prePublishErrors,
      currentBellSchedule,
    },
    methods: {
      onRowHandleClick,
      onTableChange,
      showScheduleConfigurationModal,
      hidePrePublishErrorsModal,
      handleConfirmPublish,
      setVisibleKeys,
    },
  } = useScheduleEducationPlans();

  return (
    <>
      <AppFlex direction="column" unit="16">
        <AppFlex direction="row" justifyContent="flex-end">
          <AppButton
            type="primary"
            className={styles.button}
            icon={<PlusOutlined />}
            onClick={showScheduleConfigurationModal}
          >
            Добавить конфигурацию
          </AppButton>
          <TableColumnsFilter
            visibleKeys={visibleKeys}
            columns={columns}
            setVisibleKeys={setVisibleKeys}
          />
        </AppFlex>
        <AppTable
          dataSource={dataSource ?? []}
          columns={filteredColumns}
          loading={loading}
          rowKey={(record) => record.id}
          onRow={onRowHandleClick}
          pagination={tableState.pagination}
          sorters={tableState.sorters}
          onChange={onTableChange}
        />
      </AppFlex>

      <PrePublishErrorsModal
        onCancel={hidePrePublishErrorsModal}
        visible={prePublishErrorsModalVisible}
        handleConfirmPublish={handleConfirmPublish}
        prePublishErrors={prePublishErrors}
        currentBellSchedule={currentBellSchedule}
      />
    </>
  );
};
